import { Typography } from 'antd';
import React, { useState } from 'react';
import styles from './expandableContent.module.scss';

type Props = {
	text: string;
};

const { Paragraph } = Typography;

const ExpandableContent: React.FC<Props> = ({ text }) => {
	const [expanded, setExpanded] = useState<boolean>(false);

	return (
		<>
			<Paragraph
				className={styles.renderCell}
				ellipsis={{
					rows: expanded ? 1 : undefined,
					expandable: true,
					symbol: <span className={styles.showMore}>{_('ShowMore')}</span>,
					onExpand: expansionPressed => {
						expansionPressed.preventDefault();
						setExpanded(true);
					},
				}}>
				{text}
			</Paragraph>
		</>
	);
};

export { ExpandableContent };
